"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pessoa = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const pessoa_endereco_entity_1 = require("./pessoa-endereco.entity");
const pessoa_tipo_documentacao_1 = require("./pessoa-tipo-documentacao");
let Pessoa = class Pessoa extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdPessoa = void (0);
        this.cdPessoaSuperior = void (0);
        this.cdPais = void (0);
        this.nmPessoa = void (0);
        this.nrTelefone1 = void (0);
        this.nrTelefone2 = void (0);
        this.nrCelular = void (0);
        this.nrFax = void (0);
        this.nmEmail = void (0);
        this.dtCadastro = void (0);
        this.gnPessoa = void (0);
        this.imgFoto = void (0);
        this.stCadastro = void (0);
        this.nmUrl = void (0);
        this.nmApelido = void (0);
        this.txtObservacao = void (0);
        this.lgNotificacao = void (0);
        this.idPessoa = void (0);
        this.cdClassificacao = void (0);
        this.cdFormaDivulgacao = void (0);
        this.dtChegadaPais = void (0);
        this.cdUsuarioCadastro = void (0);
        this.nrOab = void (0);
        this.nmParceiro = void (0);
        this.nrCelular2 = void (0);
        this.pessoasEnderecos = void (0);
        this.pessoasTipoDocumentacao = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_pessoa", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdPessoa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_pessoa_superior", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdPessoaSuperior", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_pais", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdPais", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_pessoa", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nmPessoa", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_telefone1", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrTelefone1", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_telefone2", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrTelefone2", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_celular", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrCelular", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_fax", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrFax", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_email", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nmEmail", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_cadastro", nullable: true }),
    __metadata("design:type", Date)
], Pessoa.prototype, "dtCadastro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "gn_pessoa", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "gnPessoa", void 0);
__decorate([
    typeorm_1.Column("blob", { name: "img_foto", nullable: true }),
    __metadata("design:type", Object)
], Pessoa.prototype, "imgFoto", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "st_cadastro", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "stCadastro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_url", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nmUrl", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_apelido", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nmApelido", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_observacao", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "txtObservacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_notificacao", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "lgNotificacao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "id_pessoa", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "idPessoa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_classificacao", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdClassificacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_forma_divulgacao", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdFormaDivulgacao", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_chegada_pais", nullable: true }),
    __metadata("design:type", Date)
], Pessoa.prototype, "dtChegadaPais", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_usuario_cadastro", nullable: true }),
    __metadata("design:type", Number)
], Pessoa.prototype, "cdUsuarioCadastro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_oab", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrOab", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_parceiro", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nmParceiro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_celular2", nullable: true, length: 100 }),
    __metadata("design:type", String)
], Pessoa.prototype, "nrCelular2", void 0);
__decorate([
    typeorm_1.OneToMany(type => pessoa_endereco_entity_1.PessoaEndereco, pessoaEndereco => pessoaEndereco.pessoa),
    __metadata("design:type", Array)
], Pessoa.prototype, "pessoasEnderecos", void 0);
__decorate([
    typeorm_1.OneToMany(type => pessoa_tipo_documentacao_1.PessoaTipoDocumentacao, pessoaTipoDocumentacao => pessoaTipoDocumentacao.pessoa),
    __metadata("design:type", Array)
], Pessoa.prototype, "pessoasTipoDocumentacao", void 0);
Pessoa = __decorate([
    typeorm_1.Entity('grl_pessoa')
], Pessoa);
exports.Pessoa = Pessoa;
